import React from 'react';
import ComponentWrapper from '../layout/ComponentWrapper';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import { createMarkup } from '../../util/functions';
import { Heading, WYSIWYG } from '../../util/typography';
import AnchorLinks from '../AnchorLinks';
import NCCNcallout from '../NCCNcallout';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';

const bp = NAVIGATION_BREAKPOINT;

const StyledComponentWrapper = styled(ComponentWrapper)`
padding: 20px;
margin-block: 20px;

border: 1px solid ${colors.pebble};
border-radius: 8px;
background-color: ${colors.white};
`;

const Wrapper = styled.div`
padding-bottom: 30px;

&:last-child {
    padding-bottom: 0;
}

@media(max-width: ${bp}){
padding-bottom: 20px;
}
`;

const Title = styled(Heading.H5)`
margin-bottom: 8px;
`;

const Text = styled(WYSIWYG)`
color: ${colors.ink};
`;

const TieredCTACard = props => {

    return (
        <StyledComponentWrapper>
            {props.tumors.map((tumor, id )=>{
                return(
                    <Wrapper>
                        <Title dangerouslySetInnerHTML={createMarkup(tumor.header)} />
                        <Text dangerouslySetInnerHTML={createMarkup(tumor.text)} />
                    </Wrapper>
                )               
            })}
        </StyledComponentWrapper>
    )
}

export default TieredCTACard;